module.exports = __webpack_public_path__ + "static/img/ico-union.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ico-union.png
// module id = 563
// module chunks = 0